/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React from 'react'

import { getNotifications } from '@builddocs/data-management'
import { useDisclosure } from '@builddocs/system'
import { Container } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography'
import { useQuery } from 'react-query'
import { Link, useMatch } from 'react-router-dom'

import NotificationItemCard from './molecules/NotificationItemCard'
import QuickSolutionDialog from './organisms/QuiсkSolutionDialog'

function CategoriesTabs() {
  // You need to provide the routes in descendant order.
  // This means that if you have nested routes like:
  // users, users/new, users/edit.
  // Then the order should be ['users/add', 'users/edit', 'users'].
  const routeMatch = useMatch('/events/*')
  const currentTab = routeMatch?.pathname

  return (
    <Tabs value={currentTab}>
      <Tab component={Link} label="Все" to="/events/" value="/events" />
      <Tab
        component={Link}
        label="Акты"
        to="/events/acts"
        value="/events/acts"
      />
      <Tab
        component={Link}
        label="Проекты"
        to="/events/projects"
        value="/events/projects"
      />
      <Tab
        component={Link}
        label="Сотрудники"
        to="/events/employees"
        value="/events/employees"
      />
    </Tabs>
  )
}

export function EventsView() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [selectedValue, setSelectedValue] = React.useState('username@gmail.com')

  const handleClickOpen = () => {
    onOpen()
  }

  const handleClose = (value: string) => {
    onClose()
    setSelectedValue(value)
  }

  const { data: notifications } = useQuery(
    ['notifications'],
    async () => await getNotifications({}),
  )

  return (
    <>
      <Container maxWidth="sm" sx={{ py: 2 }}>
        <Typography gutterBottom variant="h2">
          В потоке
        </Typography>

        <CategoriesTabs />
        <Stack alignItems="center">
          <Button sx={{ mt: 2, mx: 'auto' }} onClick={handleClickOpen}>
            Решить всё
          </Button>
        </Stack>
        <Box sx={{ p: 2, overflowY: 'auto' }}>
          <Stack spacing={2}>
            {notifications?.entityList.map(notification => (
              <NotificationItemCard
                key={notification.notificationTargetId}
                notification={notification}
              />
            ))}
          </Stack>
        </Box>
      </Container>
      <QuickSolutionDialog
        open={isOpen}
        selectedValue={selectedValue}
        onClose={handleClose}
      />
    </>
  )
}

export default EventsView
